module.exports = __webpack_public_path__ + "img/ec.e6cc1f96.png";